import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { tr } from '@util/tr';
import { toast } from '@web/util/toast';
import { Observable, of } from 'rxjs';
import { isSyncActionSuccess } from '@services/dws/sync-action-result.util';
import { resolveSyncActionErrorMessage } from '@services/dws/receipt-payment-validation.util';
import { catchError, delay, map } from 'rxjs/operators';

@Component({
  selector: 'web-external-sync-button',
  templateUrl: './external-sync-button.component.html',
  styleUrls: ['./external-sync-button.component.scss'],
})
export class ExternalSyncButtonComponent implements AfterViewInit {

  @Input() label: string = 'Sync';
  @Input() matIconName: string = 'sync';
  @Input() statusObservable: Observable<any> | null = null;
  @Input() actionObservable: Observable<any> = of(null);
  @Input() successMessage: string = tr('Synced successfully');
  @Input() errorMessage: string = tr('Error syncing, please try again');
  @Input() successPropertyName: string = 'success';
  /** WS-3531: hide menu item when status is truthy (e.g. commercial doc already issued). */
  @Input() hideWhenStatus: boolean = false;

  status: any = null;
  isSyncing: boolean = false;

  get isHidden(): boolean {
    return this.hideWhenStatus && !!this.status && !!this.statusObservable;
  }

  constructor() { }

  ngOnInit() {
    //this.getStatus();
  }

  ngAfterViewInit() {
    this.getStatus();
  }

  getStatus() {
    if (this.statusObservable) {
      this.isSyncing = true;
      this.statusObservable.subscribe(
        (status) => {
          this.isSyncing = false;
          this.status = status;
        },
        (error) => {
          this.isSyncing = false;
          console.error('Error getting status', error);
          this.status = null;
        }
      );
    }
  }

  syncClicked(event: MouseEvent) {
    event.stopPropagation();
    if (this.isSyncing || (!!this.status && this.statusObservable)) {
      return;
    }
    this.isSyncing = true;
    this.actionObservable.pipe(
      catchError((err) => of(err?.error ?? { success: false })),
      delay(500),
      map((res) => ({
        success: isSyncActionSuccess(res, this.successPropertyName),
        res,
      }))
    ).subscribe(
      ({ success, res }) => {
        this.isSyncing = false;
        if (success) {
          this.status = { lastSync: new Date() }; // just to update the UI
          toast(this.successMessage);
        } else {
          toast(resolveSyncActionErrorMessage(res, this.errorMessage));
        }
      },
      (error) => {
        this.isSyncing = false;
        toast(resolveSyncActionErrorMessage(error?.error, this.errorMessage));
      }
    );
  }
}
